import React, { useEffect, useState } from "react";
import styles from "../Carousel/caraousel.module.css";
import { Col, Row } from "react-bootstrap";
import greentickmark from "../../component/signup/assets/greenTickIcon.svg";

const BankCaraouselCard = ({
  uniqueId,
  selectedItem,
  setSelectedValue,
  selectedValue,
  selectedUserid,
  fixedwidth=false,
  type
}) => {
  const [greenCheck, setGreenCheck] = useState(false);
  var initial = selectedItem.bankName
    ? selectedItem.bankName.substring(0, 2).toUpperCase()
    : "?";

  const handleClick = () => {
    setSelectedValue(selectedItem);
  };

  useEffect(() => {
    setGreenCheck(selectedValue === selectedItem);
  }, [selectedValue, selectedItem]);

  useEffect(() => {
    if(selectedItem.bankAccountId === selectedUserid){
      setSelectedValue(selectedItem);
      setGreenCheck(true);
    }
  }, [selectedItem]);

  return (
    <div
      key={uniqueId}
      className={/*greenCheck ? styles.greenCard :*/ styles.mainCard}
      style={{
        ...(fixedwidth ? { width: "280px" } : {}),
        ...(type === "Beneficiary" ? { minHeight: "169px" } : {})
      }}
      
      onClick={handleClick}
    >
      {greenCheck ? (
        <Col style={{ position: "relative" }}>
          <img className={styles.greentick} src={greentickmark} alt="" />
        </Col>
      ) : (
        ""
      )}
      <Row>
        <Col
         md={3} xs={3}
          className={`d-flex ${styles.cardImageText}`}
        >
          <Row>
            <Col className={styles.circleName}>
              {initial}
            </Col>
          </Row>
        </Col>
        <Col md={9} sm={12} xs={9} className={styles.contentCol}>
            <p className={styles.nameHeading} style={{marginBottom: "8px"}}>
              {selectedItem.accountHolderName &&
              selectedItem.accountHolderName.length > 20
                ? `${selectedItem.accountHolderName.slice(0, 20)}...`
                : selectedItem.accountHolderName || "--"}
            </p>
            <p className={styles.textHeading}>
              Acc No:{" "}
              {selectedItem.accountMasked.length === 9
                ? selectedItem.accountMasked
                : selectedItem.accountMasked.slice(-9)}
            </p>
            <p className={styles.textHeading}>
          Bank Name:{" "}
          {selectedItem.bankName && selectedItem.bankName.length > 26
            ? `${selectedItem.bankName.slice(0, 26)}...`
            : selectedItem.bankName || "--"}
        </p>
        {type === "Beneficiary" && <p className={styles.textHeading} style={{marginBottom: "0px"}}>
              Currency: {selectedItem.currencyCode}
            </p>}
        </Col>
      </Row>
    </div>
  );
};
export default BankCaraouselCard;
